import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/play/' : '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home')
    }
  ]
})
